<template>
    <Modal @modal:dismiss="$emit('dismiss')">
        <h3 slot="header">{{ value.id ? 'Modifier' : 'Ajouter' }} un utilisateur</h3>

        <div slot="body">
            <div class="form-control">
                <label>
                    Type de compte <b>(obligatoire)</b>
                    <CustomSelect
                        class="stretch"
                        placeholder="Sélectionnez un type de compte"
                        :options="types"
                        v-model="value.type"
                        :disabled="!!value.id"
                        required
                    />
                </label>
            </div>
            <div class="form-control">
                <label>
                    Identifiant de connexion <b>(obligatoire)</b>
                    <InputUniqChecker
                        class="stretch"
                        placeholder="Renseignez un identifiant"
                        v-model="value.login"
                        :disabled="!!value.id"
                        :err-msg="`Un identifiant ${value.login} existe déjà`"
                        url="/api/check/user/login"
                        required
                    />
                </label>
            </div>
            <div class="form-control">
                <label>
                    Prénom
                    <CustomInput
                        class="stretch"
                        placeholder="Renseignez un prénom"
                        v-model="value.first_name"
                        :disabled="value.type.name === 'ldap'"
                    />
                </label>
            </div>
            <div class="form-control">
                <label>
                    Nom
                    <CustomInput
                        class="stretch"
                        placeholder="Renseignez un nom"
                        v-model="value.last_name"
                        :disabled="value.type.name === 'ldap'"
                    />
                </label>
            </div>
            <div class="form-control">
                <label>
                    Courriel
                    <CustomInput
                        class="stretch"
                        placeholder="Renseignez une adresse de courriel"
                        type="email"
                        v-model="value.email"
                        :disabled="value.type.name === 'ldap'"
                    />
                </label>
            </div>
            <div class="form-control">
                <label>
                    Mot de passe
                    <CustomInput
                        class="stretch"
                        placeholder="Renseignez un mot de passe"
                        type="password"
                        v-model="value.password"
                        :disabled="value.type.name === 'ldap'"
                    />
                </label>
            </div>
            <div class="form-control">
                <label>
                    Rôle <b>(obligatoire)</b>
                    <CustomSelect
                        class="stretch"
                        placeholder="Sélectionnez un rôle"
                        :options="roles"
                        v-model="value.role"
                        required
                    />
                </label>
            </div>
            <div class="form-control">
                <label>
                    Groupes métier
                    <CustomSelect
                        class="stretch"
                        placeholder="Sélectionnez les groupes métier"
                        :options="groups"
                        :multiple="true"
                        v-model="value.groups"
                    />
                </label>
            </div>
            <div class="form-control">
                <label>
                    Emprises de travail (laissez vide si emprise par défaut)
                    <CustomSelect
                        class="stretch"
                        placeholder="Sélectionnez les emprises de travail"
                        :options="footprints"
                        :multiple="true"
                        v-model="value.footprints"
                    />
                </label>
            </div>
        </div>

        <div slot="footer">
            <div class="form-control form-inline">
                <CustomButton class="stretch" @click="$emit('dismiss')">Annuler</CustomButton>
                <CustomButton class="default stretch" @click="$emit('close')">
                    Enregistrer
                </CustomButton>
            </div>
        </div>
    </Modal>
</template>

<script>
import Modal from './../Modal';
import CustomInput from './../Input';
import CustomButton from './../Button';
import CustomSelect from './../Select';
import InputUniqChecker from './../InputUniqChecker';

export default {
    props: ['value', 'groups', 'types', 'roles', 'footprints'],
    data() {
        return {
            name: `${this.value.first_name} ${this.value.last_name}`,
        };
    },
    components: {
        Modal,
        CustomInput,
        CustomButton,
        CustomSelect,
        InputUniqChecker,
    },
};
</script>

<style lang="scss"></style>
